export default __webpack_public_path__ + "static/media/xboxgames.4a0b26e4.png";